import clsx from 'clsx';
import type { BackgroundJobRun, BackgroundJobRunPhase } from './useBackgroundJobRun';

export const CONTINUE_IN_BACKGROUND_LABEL = 'Продолжить в фоне';

/** Класс окна (`ModalContainer`), в котором стоит `BackgroundJobWait`: шапка без прыжков, вход кнопок итога. */
export const backgroundJobWaitModalClassName = (phase: BackgroundJobRunPhase): string =>
    clsx('bg-job-wait-modal', phase === 'result' && 'bg-job-wait-modal--result');

export interface IBackgroundJobModalOptions {
    /** Название задачи в подсказке у колокольчика, когда окно уходит в фон. */
    title?: string;
    /** Закрыть окно. */
    close: () => void;
    /** Подпись кнопки отмены, пока уйти в фон нельзя. */
    cancelButtonText?: string;
}

/**
 * Обвязка окна, в котором стоит `BackgroundJobWait`: класс, «Продолжить в фоне» вместо отмены — окно улетает в
 * колокольчик и закрывается, закрыть нельзя, пока работа идёт, а уйти в фон ещё нельзя.
 */
export const backgroundJobModalProps = (
    job: Pick<BackgroundJobRun, 'phase' | 'busy' | 'background' | 'detachable' | 'detach'>,
    { title, close, cancelButtonText }: IBackgroundJobModalOptions,
) => ({
    className: backgroundJobWaitModalClassName(job.phase),
    // Итог уже пришёл, а окно доигрывает переход к нему: подпись фоновой задачи не сменяется на «Отмена».
    cancelButtonText: job.detachable || (job.busy && job.background) ? CONTINUE_IN_BACKGROUND_LABEL : cancelButtonText,
    closeDisabled: job.busy && !job.detachable,
    onCancel: job.detachable
        ? () => {
              job.detach(title);
              close();
          }
        : close,
});
